import { CreatePaneContainer } from '../../../styles/styles';
import { CreatePaneProps } from '../../../types/feedbackListTypes';
import { TemplateSelectionForm } from './components/TemplateSelectionForm';

export const CreatePane: React.FC<CreatePaneProps> = ({ candidateName, modalType, roleId }) => {
  return (
    <form>
      <CreatePaneContainer>
        <TemplateSelectionForm
          candidateName={candidateName}
          modalType={modalType}
          roleId={roleId}
        />
      </CreatePaneContainer>
    </form>
  );
};
